import { MaterialsDeliveryList } from './views';

export default {
  list: MaterialsDeliveryList,
  name: 'material-delivery-sheet',
  label: 'Materials Delivery',
  to: '/material-delivery-sheet',
};
